import { useQuery as useGetBrandView } from "@faire/web-api/api/v2/brand-view/brandToken/get-hooks";
import { IBrandViewV2Response } from "@faire/web-api/indigofair/data/IBrandViewV2Response";
import { UseQueryResult } from "@tanstack/react-query";

import { readBundledData } from "@faire/retailer/lib/bundledData";
import { useSettingLIBPReactQuery } from "@faire/retailer/settings/useSettingLIBPReactQuery";

const STALE_TIME_MS = 1 * 60 * 1000; // 1 min

export const useMaybeFetchBrandView = (
  brandToken: string
): UseQueryResult<IBrandViewV2Response> => {
  const prefetched = readBundledData("brand_view_v2", { keep: true });
  const libpReactQuery = useSettingLIBPReactQuery();

  const res = useGetBrandView(brandToken, undefined, {
    enabled: !!brandToken && libpReactQuery,
    staleTime: STALE_TIME_MS,
    initialData: () => {
      if (prefetched?.brand?.token === brandToken) {
        return prefetched;
      }
      return undefined;
    },
  });
  return res;
};
